export const AUTH_CORE_MACHINE_ID = 'authCoreMachine';

export const authCoreMachineStates = {
  authCoreMachineInitialState: 'authCoreMachineInitialState',
  getPhoneNumberOTPState: 'getPhoneNumberOTPState',
  getEmailOtpState: 'getEmailOtpState',
  newUserLoginState: 'newUserLoginState',
  phoneNumberNotVerifiedState: 'phoneNumberNotVerifiedState',
  getClientAuthCodeState: 'getClientAuthCodeState',
  getClientAuthenticationDetailsState: 'getClientAuthenticationDetailsState',
  getReferralCodesState: 'getReferralCodesState',
  otpVerificationSuccessState: 'otpVerificationSuccessState',
  emailOtpVerificationSuccessState: 'emailOtpVerificationSuccessState',
  initialState: 'initialState',
  updateUserEmail: 'updateUserEmail'
};

export const authCoreMachineEvents = {
  onClickGetOtpButton: 'ON_CLICK_GET_OTP_BUTTON',
  onSuccessOtpVerification: 'ON_SUCCESS_OTP_VERIFICATION',
  onSuccessEmailOtpVerification: 'ON_SUCCESS_EMAIL_OTP_VERIFICATION',
  onClickBackButton: 'ON_CLICK_BACK_BUTTON',
  onUpdateValuesInParentContext: 'ON_UPDATE_VALUES_IN_PARENT_CONTEXT',
  onSuccessGetOTP: 'ON_SUCCESS_GET_OTP',
  onSuccessGetEmailOTP: 'ON_SUCCESS_GET_EMAIL_OTP',
  onEntryGetOTP: 'ON_ENTRY_GET_OTP',
  onEntryGetEmailOTP: 'ON_ENTRY_GET_EMAIL_OTP',
  onErrorGetOTP: 'ON_ERROR_GET_OTP',
  onErrorGetEmailOTP: 'ON_ERROR_GET_EMAIL_OTP',
  onSuccessGetSignUpOTP: 'ON_SUCCESS_GET_SIGN_UP_OTP',
  doSelfTransition: 'DO_SELF_TRANSITION',
  goToGetPhoneNumberOtpState: 'GO_TO_GET_PHONE_NUMBER_OTP_STATE',
  goToGetEmailOtpState: 'GO_TO_GET_EMAIL_OTP_STATE',
  updatePhoneNumberInContext: 'UPDATE_PHONE_NUMBER_IN_CONTEXT',
  updateEmailInContext: 'UPDATE_EMAIL_IN_CONTEXT',
  onClickResendOtp: 'RESEND_OTP_CLICKED'
};

export const authCoreMachineServices = {
  getLoginOtp: 'getLoginOtp',
  getSignUpOTP: 'getSignUpOTP',
  getVerifiedUserOTP: 'getVerifiedUserOTP',
  getClientAuthCode: 'getClientAuthCode',
  getClientAuthenticationDetails: 'getClientAuthenticationDetails',
  getEmailOtp: 'getEmailOtp',
  verifyEmailOtp: 'verifyEmailOtp',
  updateUserEmail: 'updateUserEmail'
};

export const authCoreMachineActions = {
  setIsGetOtpButtonLoadingToTrue: 'setIsGetOtpButtonLoadingToTrue',
  setIsGetOtpButtonLoadingToFalse: 'setIsGetOtpButtonLoadingToFalse',
  clearAuthCoreMachineErrorMessageFromContext:
    'clearAuthCoreMachineErrorMessageFromContext',
  resetOtp: 'resetOtp',
  spawnExistingUserOTPFieldMachine: 'spawnExistingUserOTPFieldMachine',
  updateValuesInParentContext: 'updateValuesInParentContext',
  updateIsOtpSentToUserTrue: 'updateIsOtpSentToUserTrue',
  updateIsOtpSentToUserFalse: 'updateIsOtpSentToUserFalse',
  assignErrorMessageToContext: 'assignErrorMessageToContext',
  spawnNewUserOTPFieldMachine: 'spawnNewUserOTPFieldMachine',
  onSuccessGettingClientAuthCode: 'onSuccessGettingClientAuthCode',
  onSuccessGettingClientAuthenticationDetails:
    'onSuccessGettingClientAuthenticationDetails',
  assignValuesToContext: 'assignValuesToContext',
  updateIsNewUserInContextToTrue: 'updateIsNewUserInContextToTrue',
  updateIsNewUserInContextToFalse: 'updateIsNewUserInContextToFalse',
  redirectToCallBackUrl: 'redirectToCallBackUrl',
  redirectToFallBackUrl: 'redirectToFallBackUrl',
  redirectToHomePage: 'redirectToHomePage',
  doActionsFromParentOnEntryGetOTP: 'doActionsFromParentOnEntryGetOTP',
  doActionsFromParentOnSuccessGetOTP: 'doActionsFromParentOnSuccessGetOTP',
  doActionsFromParentOnErrorGetOTP: 'doActionsFromParentOnErrorGetOTP',
  doActionsFromParentOnSuccessGetSignUpOTP:
    'doActionsFromParentOnSuccessGetSignUpOTP',
  onInvalidRequestSignatureError: 'onInvalidRequestSignatureError',
  setAccessTokenAndRefreshTokenToContext:
    'setAccessTokenAndRefreshTokenToContext',
  doActionsFromParentOnEnterGetEmailOTP:
    'doActionsFromParentOnEnterGetEmailOTP',
  doActionsFromParentOnSuccessGetEmailOTP:
    'doActionsFromParentOnSuccessGetEmailOTP',
  doActionsFromParentOnErrorGetEmailOTP:
    'doActionsFromParentOnErrorGetEmailOTP',
  updatePhoneNumberInContext: 'updatePhoneNumberInContext',
  updateEmailInContext: 'updateEmailInContext',
  doActionFromParentOnSuccessEmailVerification:
    'doActionFromParentOnSuccessEmailVerification',
  setIsOtpSentToUserTrueInContext: 'setIsOtpSentToUserTrueInContext',
  onClickResendOtp: 'onClickResendOtp',
  onErrorGetLoginOTP: 'onErrorGetLoginOTP'
};

export const authCoreMachineGuards = {
  isNewUserError: 'isNewUserError',
  isPhoneNumberNotVerifiedError: 'isPhoneNumberNotVerifiedError',
  isInvalidRequestSignatureError: 'isInvalidRequestSignatureError'
};

export const authCoreMachineTags = {
  otpApiInitiated: 'otpApiInitiated'
};
